import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import CategoryItem from './components/CategoryItem';
import './style.scss';

interface Props {
    categorySectionTitle: string;
}

const CategorySection: React.FC<Props> = (props: Props) => {
    const { categorySectionTitle } = props;
    const {
        data: { categories },
    } = useSelector((state: ApplicationState) => state.categories);

    const screenSize: number = Constants.STUDENT_HOME_SCREEN_SIZE;
    const categoryAndHorizontalMarginsWidth = 257;
    const limitOfVisibleCategories: number = Math.round(screenSize / categoryAndHorizontalMarginsWidth);
    const [numberOfVisibleCategories, setNumberOfVisibleCategories] = useState<number>(0);

    useEffect(() => {
        if (categories && categories.length > 0) {
            const n: number = categories.length < limitOfVisibleCategories ? categories.length : limitOfVisibleCategories;
            setNumberOfVisibleCategories(n);
        }
    }, [categories, limitOfVisibleCategories]);
    const settings = {
        className: 'category-section list',
        speed: 500,
        dots: false,
        infinite: false,
        slidesToShow: numberOfVisibleCategories,
        slidesToScroll: 1,
    };

    const canSlideBeRendered = (): boolean => {
        if (categories && categories.length > 0) {
            return true;
        }
        return false;
    };

    return (
        <div className="dynamic-groupers">
            <div className="container dynamic-groupers__container container_category">
                {canSlideBeRendered() && (
                    <>
                        <h2 className="dynamic-groupers__container container_category__title">{categorySectionTitle}</h2>
                        <Slider {...settings}>
                            {categories.map((item, index) => (
                                <CategoryItem categoryType={item} key={index} />
                            ))}
                        </Slider>
                    </>
                )}
            </div>
        </div>
    );
};

export default CategorySection;
